import React from 'react';
import StudentTestAttemptMain from './StudentTestAttemptMain';

const StudentTestAttempt = () => {
    return <StudentTestAttemptMain />;
};

export default StudentTestAttempt;

